import { render, staticRenderFns } from "./SuccessPaymentTab.vue?vue&type=template&id=2efb8dac&scoped=true&"
import script from "./SuccessPaymentTab.vue?vue&type=script&lang=ts&"
export * from "./SuccessPaymentTab.vue?vue&type=script&lang=ts&"
import style0 from "./SuccessPaymentTab.vue?vue&type=style&index=0&id=2efb8dac&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2efb8dac",
  null
  
)

export default component.exports